export const common = {
  nav: {
    home: 'Home',
    projects: 'Projects',
    furniture: 'Furniture',
    news: 'News',
    contact: 'Contact',
    aiAssistant: 'AI Assistant',
    ar: 'AR Experience',
    exterior: 'Exterior',
    about: 'About Us'
  },
  hero: {
    title1: 'Nature\'s Geometry',
    title2: 'Reborn in Architecture',
    description: 'Custom furniture design, interior architecture consulting and prefabricated building solutions with amorphous forms and natural materials',
    exploreProjects: 'Explore Projects',
    viewAR: 'View with AR',
    europeanStandards: 'European Standards',
    globalDelivery: 'Global Delivery',
    arTechnology: 'AR Technology',
    customDesign: 'Custom Design'
  },
  projects: {
    title: 'Featured Projects',
    subtitle: 'Architectural and interior projects completed to global standards',
    viewDetails: 'View Details',
    istanbul: 'Istanbul, Turkey',
    dubai: 'Dubai, UAE',
    london: 'London, UK',
    paris: 'Paris, France',
    berlin: 'Berlin, Germany',
    miami: 'Miami, USA',
    project1: 'Luxury Residence with Bosphorus View',
    project2: 'Modern Office Complex',
    project3: 'Minimalist Villa Design',
    project4: 'Art Gallery Interior',
    project5: 'Boutique Hotel Project',
    project6: 'Penthouse Apartment'
  },
  ar: {
    title: 'View Your Furniture with Augmented Reality',
    subtitle: 'Experience furniture in your own space with AR technology before purchasing',
    feature1Title: 'Real-Size Viewing',
    feature1Desc: 'See furniture in real dimensions in your space',
    feature2Title: 'Instant Decision',
    feature2Desc: 'Test product compatibility with your space immediately',
    feature3Title: 'Easy to Use',
    feature3Desc: 'Experience AR in seconds with your phone',
    tryNow: 'Try Now'
  },
  furniture: {
    title: 'Custom Furniture Collections',
    subtitle: 'Unique pieces designed with natural materials and amorphous forms',
    organicTables: 'Organic Tables',
    organicTablesDesc: 'Natural wood and resin combination',
    sculptural: 'Sculptural Seating',
    sculpturalDesc: 'Artwork-quality armchairs',
    lighting: 'Lighting',
    lightingDesc: 'Handcrafted designer lamps',
    storage: 'Storage',
    storageDesc: 'Functional storage solutions',
    viewCollection: 'View Collection'
  },
  news: {
    title: 'Architecture and Design News',
    subtitle: 'Latest news and trends from the global architecture world',
    readMore: 'Read More',
    news1Title: 'New Trends in Sustainable Architecture',
    news1Desc: 'Eco-friendly materials and energy-efficient designs are transforming the architecture world',
    news2Title: 'Biophilic Design: Living with Nature',
    news2Desc: 'The use of natural elements in interiors increases health and well-being',
    news3Title: 'Smart Home Technologies 2025',
    news3Desc: 'AI-powered home systems take comfort and security to a new level'
  },
  exterior: {
    title: 'Exterior Cladding',
    subtitle: 'Modern and durable facade solutions',
    description: 'Aesthetic and functional exterior cladding systems to European standards. Custom design applications with natural stone, wood and composite materials.',
    learnMore: 'Learn More',
    prefabTitle: 'Prefabricated Buildings',
    prefabSubtitle: 'Fast and quality construction solutions',
    prefabDescription: 'High-quality projects in a short time with modular and prefabricated building systems. Energy efficiency and sustainability-focused solutions.'
  },
  testimonials: {
    title: 'Client Testimonials',
    subtitle: 'Experiences of our global clients',
    client1: 'Ahmet Yılmaz',
    client1Title: 'Villa Owner, Istanbul',
    client1Text: 'The Ernado team turned our dream home into reality. Natural materials and custom-designed furniture are amazing. Thanks to AR technology, we could see everything before purchasing.',
    client2: 'Ayşe Demir',
    client2Title: 'Hotel Manager, Antalya',
    client2Text: 'Working with Ernado for our hotel\'s interior design was a perfect experience. Their professional approach and on-time delivery made us very satisfied.',
    client3: 'Mehmet Kaya',
    client3Title: 'Architect, Ankara',
    client3Text: 'Ernado\'s expertise and quality in our prefabricated building project exceeded our expectations. European standard workmanship and material quality.',
    client4: 'Zeynep Arslan',
    client4Title: 'Interior Designer, Izmir',
    client4Text: 'Ernado\'s creativity and attention to detail in custom furniture designs is admirable. Each piece is like a work of art.',
    client5: 'Can Özdemir',
    client5Title: 'Restaurant Owner, Bodrum',
    client5Text: 'We worked with Ernado for our restaurant\'s exterior cladding and interior design. The result is magnificent, our customers constantly praise the space.',
    client6: 'Elif Şahin',
    client6Title: 'Homeowner, Bursa',
    client6Text: 'Ernado\'s consulting service was very valuable in renovating my apartment. Amorphous forms and natural materials gave my space a unique character.'
  },
  footer: {
    description: 'A global design firm offering custom furniture design, interior architecture consulting and prefabricated building solutions with natural materials and amorphous forms.',
    quickLinks: 'Quick Links',
    services: 'Our Services',
    interiorDesign: 'Interior Architecture Consulting',
    customFurniture: 'Custom Furniture Design',
    exteriorCladding: 'Exterior Cladding',
    prefabBuildings: 'Prefabricated Buildings',
    contact: 'Contact',
    newsletter: 'Newsletter',
    newsletterText: 'Stay informed about new projects and news',
    emailPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    rights: 'All rights reserved.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    addressText: 'Nilüfer, Bursa, Turkey',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use'
  },
  privacy: {
    title: 'Privacy Policy',
    intro: 'At ERNADO, we value the security and privacy of your personal data. This privacy policy explains how information collected when you visit our website is used.',
    section1Title: 'Information Collected',
    section1Text: 'When you visit our website, information such as your IP address, browser type, pages visited, and visit duration may be automatically collected. Additionally, personal information such as name, email address, and phone number that you voluntarily provide through contact forms is also collected.',
    section2Title: 'Use of Information',
    section2Text: 'The collected information is used to improve our services, respond to customer requests, conduct marketing activities, and fulfill our legal obligations.',
    section3Title: 'Information Security',
    section3Text: 'We use industry-standard security measures to protect your personal data. However, please note that no data transmission over the internet is 100% secure.',
    section4Title: 'Third Party Sharing',
    section4Text: 'We do not share your personal information with third parties except as required by law. Our service providers may only access information necessary to provide services on our behalf.',
    section5Title: 'Cookies',
    section5Text: 'Our website may use cookies to improve user experience. You can manage or reject cookies through your browser settings.',
    contact: 'If you have questions about our privacy policy, please contact us: ernado@outlook.com.tr'
  },
  terms: {
    title: 'Terms of Use',
    intro: 'By using the ERNADO website, you agree to the following terms of use. Please read these terms carefully.',
    section1Title: 'Service Usage',
    section1Text: 'Our website and content may only be used for lawful purposes. When using our site, you agree to respect laws, regulations, and third-party rights.',
    section2Title: 'Intellectual Property',
    section2Text: 'All content, designs, logos, images, and text on our website are the property of ERNADO and are protected by copyright laws. Unauthorized use, copying, or distribution is prohibited.',
    section3Title: 'Disclaimer',
    section3Text: 'We strive to ensure the accuracy of information on our website, but we do not guarantee that the information is complete or current. ERNADO cannot be held responsible for any damage or loss resulting from the use of the website.',
    section4Title: 'Links',
    section4Text: 'Our website may contain links to third-party websites. These links are provided for convenience only, and ERNADO is not responsible for the content or privacy practices of these sites.',
    section5Title: 'Changes',
    section5Text: 'ERNADO reserves the right to change these terms of use at any time. Changes take effect as soon as they are published on the website.',
    section6Title: 'Contact',
    section6Text: 'If you have questions about the terms of use, please contact us: ernado@outlook.com.tr'
  }
};